




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GJgrowEventCreateConfirmViewItemCell',
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateItemCell extends Vue {
  mounted() {}
}
